var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterInOrderDescIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3869_85020)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H1V15H16V16H0V0ZM10 11.5C10 11.6326 10.0527 11.7598 10.1464 11.8536C10.2402 11.9473 10.3674 12 10.5 12H14.5C14.6326 12 14.7598 11.9473 14.8536 11.8536C14.9473 11.7598 15 11.6326 15 11.5V7.5C15 7.36739 14.9473 7.24021 14.8536 7.14645C14.7598 7.05268 14.6326 7 14.5 7C14.3674 7 14.2402 7.05268 14.1464 7.14645C14.0527 7.24021 14 7.36739 14 7.5V10.1L10.387 5.683C10.3428 5.62901 10.2877 5.58489 10.2254 5.55345C10.1631 5.52202 10.0949 5.50398 10.0252 5.5005C9.9555 5.49701 9.88584 5.50816 9.8207 5.53322C9.75556 5.55828 9.69639 5.5967 9.647 5.646L7.06 8.233L3.404 3.206C3.32402 3.1043 3.20774 3.03757 3.07958 3.01981C2.95143 3.00206 2.82138 3.03467 2.71677 3.1108C2.61216 3.18693 2.54113 3.30064 2.51861 3.42805C2.49609 3.55545 2.52383 3.68662 2.596 3.794L6.596 9.294C6.63846 9.35249 6.69309 9.40107 6.75613 9.43641C6.81917 9.47175 6.88912 9.49301 6.96117 9.49871C7.03322 9.50441 7.10564 9.49443 7.17346 9.46945C7.24128 9.44446 7.30287 9.40508 7.354 9.354L9.963 6.744L13.445 11H10.5C10.3674 11 10.2402 11.0527 10.1464 11.1464C10.0527 11.2402 10 11.3674 10 11.5Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3869_85020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterInOrderDescIcon);
export default __webpack_public_path__ + "static/media/filter-in_order-desc-icon.62313f12c7d07e3025f357d005cabd69.svg";
export { ForwardRef as ReactComponent };